import apiClient from "@/utils/axios";
import { ApiResponse } from "@/interfaces/api-response";
import { ItemView } from "@/interfaces/common.interface";
import { FilterQuery } from "@/stores/order-filter.store";
import { Customization } from "@/interfaces/customization.interface";

const getMany = async (params: {
  page: number;
  size: number;
  search?: string;
  filters?: Partial<FilterQuery>;
  view?: ItemView;
}) => {
  const { page, size, search, filters, view } = params;
  const response = await apiClient.get<ApiResponse<Customization[]>>(
    `/customizations`,
    {
      params: {
        page,
        size,
        search,
        view,
        ...filters,
      },
    },
  );
  return response.data;
};

const getOne = async (id: string) => {
  const response = await apiClient.get<ApiResponse<Customization>>(
    `/customizations/${id}`,
  );
  return response.data;
};

const updateOne = async (id: string, data: Partial<Customization>) => {
  const response = await apiClient.put<Customization>(
    `/customizations/${id}`,
    data,
  );
  return response.data;
};

const printManually = async (id: string) => {
  const response = await apiClient.get<ApiResponse<Customization>>(
    `/prints/manual/${id}`,
  );
  return response.data;
};

const customizationApi = {
  getMany,
  getOne,
  updateOne,
  printManually,
};

export default customizationApi;
